import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { NumericFormat } from 'react-number-format'
import React from 'react'

type Props = {
  label?: string | React.ReactNode
  inline?: boolean
  prepend?: string | React.ReactNode
  addon?: string | React.ReactNode
  name?: string
  value?: string | number | null | any
  placeholder?: string
  maxLength?: number
  disabled?: boolean
  optional?: boolean
} & React.ComponentPropsWithoutRef<'input'>

export function NumberFormatInput(props: Props) {
  const { label, inline, prepend, addon, id, name, value, placeholder, maxLength, disabled, optional, onChange, onBlur, onFocus } = props
  const errMsg = _.get(props, 'data-error')
  return (
    <div>
      {
        label &&
        <label htmlFor={id || name} className={twMerge('form-label')}>
          {label}
          {
            optional &&
            <span className='font-light ml-1.5 text-zinc-600 dark:text-zinc-400'>(optional)</span>
          }
        </label>
      }
      <div className={twMerge('form-container', inline ? 'mt-0' : 'mt-1')}>
        {
          prepend &&
          <div className='form-prepend'>
            {prepend}
          </div>
        }
        <NumericFormat
          thousandSeparator=','
          autoComplete='off'
          id={id || name}
          name={name}
          value={value}
          placeholder={placeholder || ''}
          maxLength={maxLength || undefined}
          disabled={disabled}
          className='form-input'
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
        />
        {
          addon &&
          <div className='form-addon'>
            {addon}
          </div>
        }
      </div>
      {
        errMsg && <div className='form-error-message'>{errMsg}</div>
      }
    </div >
  )
}